import { productFamilyIdFormat, productIdFormat } from "@redotech/redo-ids/ids";
import { AttributeValuesSchema } from "@redotech/redo-inventory-common/attributes";
import { ListingTypeSchema } from "@redotech/redo-model/inventory/base-listing";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum OptimizationStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  SKIPPED = "skipped",
}
export const OptimizationStatusSchema = createEnum(OptimizationStatus);

const FieldOptimizationUpdateSchema = z.object({
  type: z.literal("field"),
  field: z.string(),
  status: OptimizationStatusSchema,
  originalValue: AttributeValuesSchema.nullable(),
  optimizedValue: AttributeValuesSchema.nullable(),
  allowWordAnimation: z.boolean(),
});
export type FieldOptimizationUpdate = z.infer<
  typeof FieldOptimizationUpdateSchema
>;

const ProgressUpdateSchema = z.object({
  type: z.literal("progress"),
  message: z.string(),
});
export type ProgressUpdate = z.infer<typeof ProgressUpdateSchema>;

export const OptimizationUpdateSchema = z.discriminatedUnion("type", [
  FieldOptimizationUpdateSchema,
  ProgressUpdateSchema,
]);
export type OptimizationUpdate = z.infer<typeof OptimizationUpdateSchema>;

export const streamListingFieldOptimization = unaryStreamRpc({
  name: "streamListingFieldOptimization" as const,
  input: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    productId: productIdFormat.schema.optional(),
    listingType: ListingTypeSchema,
    fields: z.array(z.string()),
  }),
  output: OptimizationUpdateSchema,
});
